import { Injectable } from '@angular/core';
import { SessionExpireDialogComponent } from '../components/dialogs/session-expire-dialog.component';
import { LogService } from './log.service';
import { ITimer } from '../interfaces/ITimer';
import { environment } from '../../environments/environment';
import { ModalService } from './modal.service';
import { MessageService } from './message.service';

@Injectable({
  providedIn: 'root'
})
export class SessionTimerService implements ITimer {
  private readonly maxSessionTimeout =
    environment.settings.session_timer.timeout;
  private readonly intervalInMillis =
    environment.settings.session_timer.interval;
  private timer: number;
  private onSessionTerminate: Function;
  private currentSessionTimeout: number;

  constructor(private log: LogService, 
    private messageService: MessageService,
    private modalService: ModalService) {}

  onSessionTerminateEvent(onSessionTerminate: Function) {
    this.onSessionTerminate = onSessionTerminate;
  }

  resetIdleCountdown() {
    this.currentSessionTimeout = this.maxSessionTimeout;
  }

  start() {
    if (!this.timer) {
      this.currentSessionTimeout = this.maxSessionTimeout;

      this.log.trace('SessionTimer.start', {
        expiration: this.currentSessionTimeout
      });

      this.timer = window.setInterval(() => {
        this.currentSessionTimeout -= this.intervalInMillis;
        this.log.trace('SessionTimer.check', {
          activatedIn: this.currentSessionTimeout
        });

        if (this.currentSessionTimeout <= 0) {
          this.stop();

          this.modalService.close();

          this.modalService.open(
            SessionExpireDialogComponent,
            null,
            () => {
              this.log.trace('extend session');
              this.messageService.postRefreshMessage();
              this.start();
            },
            () => {
              this.log.trace('logout');
               this.onSessionTerminate();
            }
          );
        }
      }, this.intervalInMillis);
    }
  }

  stop() {
    if (this.timer) {
      window.clearTimeout(this.timer);
    }
    this.timer = null;
  }

  restart() {
    this.stop();
    this.start();
  }
}
